import React from "react";
import { NavLink } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from './Topbar';

const Layout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-blue-50">
      <Sidebar />
      {/* Main Content */}
      <div className="flex-1 flex flex-col ml-20">
        <Topbar />
        <main className="flex-1 p-6">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
